// removed by extract-text-webpack-plugin
module.exports = {"grid":"_113lI","result":"_3JL9L"};